export const parseMoney = (amount?: number) => {
    if (!amount) { amount = 0 };
    let money = amount.toFixed(2)
    money = money.replace(".", ",")
    return `€ ${money}`
}